<template>
  <div v-if="recipe">
    <div class="buttons" style="margin-bottom: 3px">
      <button class="button" v-on:click="$router.push('/')">
        <span class="icon">
          <i class="fas fa-home"></i>
        </span>
        <span>Home</span>
      </button>
      <a href="javascript:false" class="button" v-on:click="$impressions.externalClick('recipe_print', `https://hmyrecipefinder.co/home/printrecipe?recipe=${recipe.id}`)">
        <span class="icon">
          <i class="fas fa-print"></i>
        </span>
        <span>Print</span>
      </a>
    </div>
    <div class="columns is-variable is-2 is-multiline is-mobile">
      <div class="column is-one-third-desktop is-full-tablet is-full-mobile">
        <div class="card summary">
          <v-lazy-image
              :src="recipe.image || 'https://via.placeholder.com/500.png?text=' + encodeURIComponent(recipe.title)"
              src-placeholder="https://www.brownweinraub.com/wp-content/uploads/2017/09/placeholder.jpg"
          />
          <h1>{{ recipe.title }}</h1>
          <span>By {{ recipe.sourceName }}</span>
          <p>{{ stripHtml(recipe.summary) }}</p>
        </div>
      </div>
      <div class="column is-one-third-desktop is-full-tablet is-full-mobile">
        <div class="card">
          <h1>Dietary Facts</h1>
          <div class="facts">
            <span><b>Servings:</b> {{ recipe.servings }}</span>
            <span><b>Est. Price/Serving:</b> ${{ (recipe.pricePerServing / 100).toFixed(2) }}</span>
            <span><b>Total Time:</b> {{ recipe.readyInMinutes }} minutes</span>
            <span><b>Ketogentic:</b> {{ recipe.ketogenic ? "Yes" : "No" }}</span>
            <span><b>Gluten Free:</b> {{ recipe.glutenFree ? "Yes" : "No" }}</span>
            <span><b>Dairy Free:</b> {{ recipe.dairyFree ? "Yes" : "No" }}</span>
            <span><b>Vegan:</b> {{ recipe.vegan ? "Yes" : "No" }}</span>
            <span><b>Vegetarian:</b> {{ recipe.vegetarian ? "Yes" : "No" }}</span>
          </div>
        </div>
        <div class="card">
          <h1>Ingredients</h1>
          <div class="ingredients">
            <span v-for="ingredient in recipe.extendedIngredients" :key="ingredient.key">{{ ingredient.original }}</span>
          </div>
        </div>
      </div>
      <div class="column is-one-third-desktop is-full-tablet is-full-mobile">
        <div class="card">
          <h1>Instructions</h1>
          <div v-if="recipe.analyzedInstructions.length > 0" class="instructions">
            <span v-for="step in recipe.analyzedInstructions[0].steps" :key="step.key">{{ step.step }}</span>
          </div>
          <div v-else-if="recipe.instructions" class="instructions">
            <p>{{ stripHtml(recipe.instructions) }}</p>
          </div>
          <div v-else class="instructions">
            <p>
              We seemed to have misplaced the instructions for this recipe...<br><br>
              <b>Click here to view the recipe page:</b>
            </p>
            <a href="javascript:false" target="_blank" class="button" v-on:click="$impressions.externalClick('external_recipe', recipe.sourceUrl)">View Recipe</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import "../styles/Recipe"
</style>

<script>
import VLazyImage from "v-lazy-image";

export default {
  components: { VLazyImage },
  async beforeCreate() {
    const id = parseInt(this.$route.params.id);
    const cached = await this.$recipes.GetRandom();

    this.recipe = Array.from(cached).find(obj => obj.id === id) || await this.$recipes.GetInformation(id);
    document.title = this.recipe.title + ' - My Recipe Finder';
  },
  methods: {
    stripHtml(html){
      const tempText = document.createElement("div");
      tempText.innerHTML = html;
      return tempText.textContent || tempText.innerText || "";
    }
  },
  data() {
    return {
      recipe: undefined
    }
  }
}
</script>